<div class="app-container">
  <header class="app-header">
    <div class="header-content">
      <img
        ngSrc="assets/images/TRASDATA_blanco.png"
        alt="Trasdata Logo"
        class="logo"
        width="1536"
        height="459"
        priority
        disableOptimizedSrcset
      />

      <div class="user-info" *ngIf="isAuthenticated && userName">
        <div class="user-name">
          <mat-icon>person</mat-icon>
          <span>{{ userName }}</span>
        </div>
        <button mat-icon-button (click)="onLogout()" matTooltip="Cerrar sesión" class="logout-btn">
          <mat-icon>logout</mat-icon>
        </button>
      </div>

      <img
        ngSrc="assets/images/LOGOESCUDOSDS-optimized.png"
        alt="Escudos Logo"
        class="escudos-logo"
        width="400"
        height="85"
        priority
      />
    </div>
  </header>

  <main class="app-main">
    <router-outlet></router-outlet>
  </main>

  <footer class="app-footer">
    <div class="footer-content">
      <img
        ngSrc="assets/images/header_govco.png"
        alt="Gobierno de Colombia"
        class="gov-logo"
        width="200"
        height="47"
      />
      <p>&copy; 2025 Trasdata. Todos los derechos reservados.</p>
    </div>
  </footer>
</div>
